/* ==========================================================================
   Bam Deals - homepage row banners become clickable
   Loaded on the index template only, from layout/theme.liquid.

   WHY THIS EXISTS
   Each homepage product row (Weekly Deals, Value Packs, New Arrivals, Best
   Sellers) sits under a wide banner set through the section's `banner_cart`
   image setting. Every one of those banners has its call to action - "SHOP
   DEALS", "SHOP VALUE PACKS", "EXPLORE NEW", "SHOP FAVORITES" - PAINTED
   INTO THE ARTWORK. It is a flat JPG, not markup, so there was nothing for
   the browser to click: shoppers were clicking a picture of a button and
   nothing happened.

   sections/featured-collection.liquid exposes no link setting for that image,
   and that file is ~25KB of theme code we would rather not fork just to wrap
   one <img> in an <a>. So the anchor is added here instead - a bare overlay
   stretched across the banner. The artwork is untouched and it looks
   identical; the whole banner simply becomes the button it already depicts.

   HOW A BANNER FINDS ITS COLLECTION
   Nothing in the rendered markup names the section's collection, so the map
   below is explicit. The keys are the section IDs from templates/index.json;
   Shopify prefixes them at render time with `template--<id>__`, which is why
   this matches on substring rather than equality. A section that is not in
   the map is skipped, so adding a new banner row means adding a line here.

   The overlay is styled inline on purpose. It keeps the behaviour in one
   file - there is no companion rule to keep in sync across the bamdeals-*.css
   set. `position: relative` on `.custom-container > .images` is already set
   by bamdeals-weekly-deals.css, so `inset: 0` resolves against the banner.
   z-index 2 clears the image; the slider arrows sit at 3 and stay clickable
   above it.
   ========================================================================== */

(function () {
  var TARGETS = {
    featured_collection_QBxiB3: {
      href: '/collections/special-of-the-week',
      label: 'Shop weekly deals'
    },
    featured_collection_me9inY: {
      href: '/collections/value-pack',
      label: 'Shop value packs'
    },
    featured_collection_F3k6FA: {
      href: '/collections/new-arrivals',
      label: 'Shop new arrivals'
    },
    featured_collection_7qHgDU: {
      href: '/collections/best-selling',
      label: 'Shop best sellers'
    }
  };

  var KEYS = Object.keys(TARGETS);

  function linkBanners() {
    var sections = document.querySelectorAll('.m-featured-collection.banner-top');

    Array.prototype.forEach.call(sections, function (section) {
      var id = section.getAttribute('data-section-id') || section.id || '';
      var key = null;

      for (var i = 0; i < KEYS.length; i++) {
        if (id.indexOf(KEYS[i]) !== -1) {
          key = KEYS[i];
          break;
        }
      }

      if (!key) return;

      var holder = section.querySelector('.custom-container > .images');
      if (!holder) return;
      /* Re-entrant: shopify:section:load fires again in the theme editor. */
      if (holder.querySelector('a.bamdeals-banner-link')) return;

      var link = document.createElement('a');
      link.className = 'bamdeals-banner-link';
      link.href = TARGETS[key].href;
      link.setAttribute('aria-label', TARGETS[key].label);
      link.style.cssText =
        'position:absolute;top:0;right:0;bottom:0;left:0;display:block;z-index:2;';

      holder.appendChild(link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkBanners);
  } else {
    linkBanners();
  }

  document.addEventListener('shopify:section:load', linkBanners);
})();
